import type { MouseEventHandler } from 'react';

import { Box, Typography } from '@mui/material';

import logo from '@/assets/images/gxLogo.svg';

type GoLogoProps = {
  size?: number;
  open?: boolean;
  onClick?: MouseEventHandler<HTMLElement>;
};

const GoLogo = ({ size = 64, open = true, onClick }: GoLogoProps) => {
  let cursorStyle = 'initial';
  if (onClick) {
    cursorStyle = open ? 'w-resize' : 'e-resize';
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        cursor: cursorStyle
      }}
      onClick={onClick}
    >
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          alignItems: 'flex-start'
        }}
      >
        <Box
          alt='GX'
          component='img'
          src={logo}
          sx={{
            display: 'flex',
            height: `${size}px`
          }}
        />
      </Box>
      {open && (
        <Typography
          color='primary'
          fontSize={`${size}px`}
          fontWeight={500}
          lineHeight={1}
          marginLeft={0.5}
          sx={{ userSelect: 'none' }}
        >
          Go
        </Typography>
      )}
    </Box>
  );
};

export default GoLogo;
